var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-04-01
 * @brief userUtils module
 *
 ********************************************************************/
//utils
import * as HttpUtil from "../../utils/api/HttpUtil";
import * as CUTIL from "../../utils/commUtils";
import * as CONST from "../../utils/Const";
/**
 * @brief 사용자 상세정보 요청 및 recoil setting 컴포넌트
 * @param
 * @returns react components
 */
export function getDetailUserInfoR(loginInfo) {
    return __awaiter(this, void 0, void 0, function* () {
        let userInfo = {
            userIdPk: -1,
            loginTime: "",
            userId: "",
            email: "",
            userName: "",
            phoneNumber: "",
            companyName: "",
            zoneName: "",
            department: "",
            role: "",
            language: "",
            nickName: "",
            userRank: "",
            userImage: "",
            isAutomatedNickName: false,
            classificationCode: -1,
            classification: "",
            agreeMailReceipt: false,
            agreeTos: false,
            agreePersonalInfo: false,
            agreeData: false,
        };
        let data = null;
        data = yield HttpUtil.PromiseHttp({
            httpMethod: "GET",
            appPath: "/user",
            appQuery: {},
            userToken: loginInfo.token,
        });
        if (data) {
            if (data.codeNum === CONST.API_200) {
                userInfo = {
                    loginTime: CUTIL.curTimeString(),
                    userIdPk: data.body.userIdPk,
                    userId: data.body.userId,
                    email: data.body.email,
                    userName: data.body.userName,
                    phoneNumber: data.body.phoneNumber,
                    companyName: data.body.companyName,
                    zoneName: data.body.zoneName,
                    department: data.body.department,
                    role: data.body.role,
                    language: data.body.language,
                    nickName: data.body.nickName,
                    userRank: data.body.userRank,
                    userImage: data.body.userImage,
                    isAutomatedNickName: data.body.isAutomatedNickName,
                    classificationCode: data.body.classificationCode,
                    classification: data.body.classification,
                    agreeMailReceipt: data.body.agreeMailReceipt,
                    agreeTos: data.body.agreeTos,
                    agreePersonalInfo: data.body.agreePersonalInfo,
                    agreeData: data.body.agreeData,
                };
            }
        }
        return userInfo;
    });
}
